<template>
  <div class="poster-create">
    <el-form ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="100px">
      <div class="title">基础配置</div>
      <el-form-item label="活动页名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入，限16字" maxlength="16" />
      </el-form-item>
      <el-form-item label="描述说明" prop="remark" class="not-required">
        <el-input type="textarea" rows="6" v-model="form.remark" placeholder="请输入，限200字" maxlength="200" show-word-limit />
      </el-form-item>
      <div class="title">海报配置</div>
      <div class="poster-box">
        <div class="poster-item" v-for="(item, index) in posterList" :key="item.id">
          <div class="index">海报{{ index + 1 }}</div>
          <div class="poster-form">
            <div class="left">
              <el-form-item label="图片" prop="img" :rules="[{validator: (r, v, c) => checkListForm(r, v, c, index)}]">
                <!-- <span>{{ item.img ? item.img.name : '' }}</span> -->
                <UploadImg @getUploadFile="(file)=>{ item.img = file }" :uploadUrl="item.img" :maxSize="1" desc=""></UploadImg>
                <div class="remark">点击本地上传，小于1mb</div>
              </el-form-item>
            </div>
            <div class="right">
              <el-form-item label="配置类型" prop="type" >
                <el-radio-group v-model="item.type">
                  <el-radio label="base">内部链接</el-radio>
                  <el-radio label="miniprogram">小程序跳转</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="" prop="page" v-if="item.type == 'base'" :rules="[{validator: (r, v, c) => checkListForm(r, v, c, index)}]">
                <el-input v-model="item.page" placeholder="请输入跳转链接" ></el-input>
              </el-form-item>
              <el-form-item label="" prop="appId" v-if="item.type=='miniprogram'" :rules="[{validator: (r, v, c) => checkListForm(r, v, c, index)}]">
                <el-input v-model="item.appId" placeholder="请输入appId"></el-input>
              </el-form-item>
              <el-form-item label="" prop="page" v-if="item.type=='miniprogram'">
                <el-input v-model="item.page" placeholder="请输入跳转链接"></el-input>
              </el-form-item>
              <el-form-item label="商场类型" prop="scopeType">
                <el-radio-group v-model="item.scopeType">
                  <el-radio label="AllMall">所有商场</el-radio>
                  <el-radio label="Mall">指定商场</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="item.scopeType == 'Mall'" prop="mallIds" label="" label-width="230px" :rules="[{validator: (r, v, c) => checkListForm(r, v, c, index)}]" >
                <el-select v-model="item.mallIds" placeholder="请选择商场" filterable multiple collapse-tags>
                  <el-option v-for="mallItem in mallOption" :key="mallItem.id" :label="mallItem.name" :value="mallItem.id"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <el-button v-if="posterList.length > 1" type="danger" @click="onDelete(index)" >删除</el-button>
          </div>
        </div>
        <el-button class="addBtn" type="primary" @click="onAdd" >+ 新增</el-button>
      </div>
    </el-form>
    <div class="footer">
      <el-button @click="onBack" class="fun-btn mr20">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="onSubmit" class="fun-btn">确定</el-button>
    </div>
  </div>
</template>

<script>
import UploadImg from '@/components/UploadImg/index'
import { api_getMallDesc, api_putUpdatePosters, api_postCreatedPosters, api_getPostersDetail } from '@/api/posterList'
import { api_postFileUpload, api_getConfig } from '@/api/common'
export default {
  name: "SCPosterListAdd",
  components: {
    UploadImg,
  },
  data() {
    // 校验海报form
    const checkListForm = (rule, v, callback, index) => {
      const { field } = rule
      const value = this.posterList[index][field]
      if (field == 'appId' && !value) {
        callback(new Error('请输入'))
      } else if (field == 'img' && value === null) {
        callback(new Error('请上传图片'))
      } else if (field == 'page' && this.posterList[index].type == 'base' && !value) {
        callback(new Error('请输入'))
      } else if (field == 'mallIds' && !value.length) {
        callback(new Error('请选择'))
      } else {
        callback()
      }
    }

    return {
      form: {},
      mallOption: [],
      rules: {
        name: [{ required: true, message: '请输入活动页名称' }],
      },
      posterList: [],
      checkListForm,
      showImg: true,
      submitLoading: false
    };
  },
  created() {
    if (this.$route.query.id) {
      this.$route.meta.breadcrumbTitle = '<span class="noblack">服务配置/活动页<span class="black">/编辑</span></span>'
      this.getInfo()
    } else {
      this.$route.meta.breadcrumbTitle = '<span class="noblack">服务配置/活动页<span class="black">/创建</span></span>'
      this.onAdd()
    }
    this.getConfigData()
  },
  methods: {
    // 获取config数据（商场、店铺级联框）
    async getConfigData() {
      let {mall} = await api_getConfig(['mall'])
      this.mallOption = mall
    },

    // 新增海报
    onAdd() {
      this.posterList.push({
        id: 'custom' + new Date().getTime(),
        type: 'base',
        scopeType: 'AllMall',
        img: null,
      })
    },

    // 删除海报
    onDelete(index) {
      this.posterList.splice(index, 1)
    },

    // 点击提交按钮
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {

          try {
            this.submitLoading = true
            let params = {
              ...this.form,
              posters: [...this.posterList],
            }

            for (let i = 0; i < params.posters.length; i++) {
              if (params.posters[i].img.size) {
                const { key } = await api_postFileUpload(params.posters[i].img, 'PosterActivityImg')
                params.posters[i].imgKey = key
              }
              if (params.posters[i].mallIds && !params.posters[i].mallIds.length) {
                delete params.posters[i].mallIds
              }
              if ((params.posters[i].id + '').indexOf('custom') >= 0) {
                delete params.posters[i].id // 删除自定义id
              }
              delete params.posters[i].img
              delete params.posters[i].type
              delete params.posters[i].scopeType
              delete params.posters[i].imgUrl
            }
            console.log('params: ', params);
            // return
            this.$route.query.id ? await api_putUpdatePosters({...params, id: this.$route.query.id}) : await api_postCreatedPosters(params)
            this.$baseMessage('操作成功', 'success')
            this.onBack()
            this.submitLoading = false
          } catch (err) {
            console.log('err: ', err);
            this.submitLoading = false
          }
        }
      })
    },

    // 获取详情数据
    async getInfo () {
      const res = await api_getPostersDetail({id: this.$route.query.id})
      console.log('res: ', res);
      this.form = {
        name: res.name,
        remark: res.remark || '',
        disable: res.disable,
      }
      this.posterList = res.posters.map(item => {
        return {
          ...item,
          type: item.appId ? 'miniprogram' : 'base',
          scopeType: item.mallIds && item.mallIds.length ? 'Mall' : 'AllMall',
          img: item.imgUrl || '',
        }
      })
    },
    // 返回
    onBack() {
      this.$router.back(-1)
    },
  },
};
</script>

<style lang="scss" scoped>
.poster-create {
  width: 100%;
  padding: 35px 20px;
  padding-bottom: 100px;
  box-sizing: border-box;
  position: relative;
  .el-input,
  .el-textarea,
  .el-select {
    width: 350px;
  }

  .input-remark {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
    position: absolute;
    left: 350px;
    bottom: 0;
  }

  .optional {
    height: 17px;
    line-height: 17px;
    margin-top: 5px;
    font-size: 12px;
    color: #666666;
  }
  ::v-deep{
    .avatar-uploader{
      height: 152px;
    }
  }

  .footer{
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
  }

  .title {
    margin: 0;
    margin-bottom: 30px;
    padding-left: 15px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      width: 5px;
      height: 25px;
      border-radius: 2px;
      background: #05C8AF;
    }

    .title-remark {
      color: #666666;
      font-size: 14px;
    }
  }
  .remark {
    font-size: 12px;
    color: #999;
  }
  .poster-box {

    .poster-item {
      margin-top: 20px;
      .index {
        margin-bottom: 10px;
        font-weight: 500;
      }
      .poster-form {
        border: 1px solid #ccc;
        border-radius: 2px;
        padding: 20px 10px;
        display: flex;
        justify-content: flex-start;
        .left {
          margin-right: 20px;
        }
        .right {
          flex: 1;
        }
      }
    }

    .addBtn {
      margin-top: 10px;
    }
  }
}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
